var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.33325C16.5523 4.33325 17 4.78097 17 5.33325V18.919L19.9596 15.9595C20.3501 15.569 20.9832 15.569 21.3738 15.9595C21.7643 16.35 21.7643 16.9832 21.3738 17.3737L16.7071 22.0404C16.3166 22.4309 15.6834 22.4309 15.2929 22.0404L10.6262 17.3737C10.2357 16.9832 10.2357 16.35 10.6262 15.9595C11.0168 15.569 11.6499 15.569 12.0404 15.9595L15 18.919V5.33325C15 4.78097 15.4477 4.33325 16 4.33325ZM7 26.6666C7 26.1143 7.44772 25.6666 8 25.6666H24C24.5523 25.6666 25 26.1143 25 26.6666C25 27.2189 24.5523 27.6666 24 27.6666H8C7.44772 27.6666 7 27.2189 7 26.6666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f50ea0c099ee70ba4eed89d543f449bf.svg";
export { ForwardRef as ReactComponent };